module.exports = __webpack_public_path__ + "static/img/catalogue_general.97f8c6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/catalogue_general.jpg
// module id = 27
// module chunks = 0